import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader1 from "../../components/common/PageHeader1";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { GetSleepstoriesList,handleDeleteStory} from "../../services/SleepStories";

function SleepStoriesList() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [stories, setStories] = useState([]);

  // ✅ Fetch Sleep Stories
  const getStoriesList = async () => {
    setIsLoading(true);
    try {
      const response = await GetSleepstoriesList();

      if (response.success === false) {
        toast.error(response.message || "Failed to load sleep stories");
        return;
      }

      // Response format:
      // { message: "Playlists fetched", data: [ ... ] }
      const data = response.data || [];

      setStories(
        data.map((item, index) => ({
          id: item._id,
          sno: index + 1,
          title: item.title,
          description: item.description,
          category: item.category,
          thumbnail: item.thumbnail,
          voice: item.voice,
          duration: item.duration,
          languages: item.languages,
          createdAt: item.createdAt,
        }))
      );
    } catch (error) {
      console.error("Error fetching sleep stories:", error);
      toast.error("Failed to load sleep stories");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getStoriesList();
  }, []);

  // ✅ DataGrid Columns
  const columns = [
    { field: "sno", headerName: "S.No", width: 80 },
    { field: "title", headerName: "Title", width: 250 },
    { field: "category", headerName: "Category", width: 150 },
    { field: "duration", headerName: "Duration (min)", width: 140 },
    { field: "languages", headerName: "Language", width: 120 },
    {
      field: "thumbnail",
      headerName: "Thumbnail",
      width: 150,
      renderCell: (params) =>
        params.row.thumbnail ? (
          <img
            src={params.row.thumbnail}
            alt="thumb"
            style={{
              width: 60,
              height: 60,
              borderRadius: 8,
              objectFit: "cover",
            }}
          />
        ) : (
          <span>No Image</span>
        ),
    },
    {
      field: "voice",
      headerName: "Audio Preview",
      width: 180,
      renderCell: (params) =>
        params.row.voice ? (
          <audio controls style={{ width: "100%" }}>
            <source src={params.row.voice} type="audio/mp3" />
          </audio>
        ) : (
          <span>No Audio</span>
        ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 180,
      renderCell: (params) =>
        new Date(params.row.createdAt).toLocaleString("en-IN"),
    },
    {
          field: "action",
          headerName: "Action",
          width: 150,
          renderCell: (params) => (
            <div className="btn-group">
              
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm me-2"
                onClick={() => navigate(`/edit-sleep-story/${params.row.id}`)}
              >
                <i className="icofont-edit text-success"></i>
              </button>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                 onClick={() => handleDeleteStory(params.row.id, getStoriesList)}
               
              >
                <i className="icofont-ui-delete"></i>
              </button>
            </div>
          ),
        },
  ];

  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1 pagetitle="Sleep Stories List" />
        <div className="textAlign-right mb-3">
            <Link to="/create-sleep-story" className="btn btn-primary" >
                Add New
            </Link> 
        </div>

        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
                <DataGrid
                  rows={stories}
                  columns={columns}
                  loading={isLoading}
                  autoHeight
                  disableSelectionOnClick
                  pageSize={10}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  sx={{ border: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SleepStoriesList;
